import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tethered-time-input',
  templateUrl: './tethered-time-input.component.html',
  styleUrls: ['./tethered-time-input.component.css']
})
export class TetheredTimeInputComponent {

  minValue: number = 0;
  timeOne: any = {hours: '00', seconds: '00', minutes: '00'};
  timeTwo: any = {hours: '00', seconds: '00', minutes: '00'};
  @Input() labelOne;
  @Input() labelTwo;
  @Input() valueOne: number = 0;
  @Input() valueTwo: number = 0;
  @Output() valueOneChange = new EventEmitter<number>();
  @Output() valueTwoChange = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
    this.timeOne = this.calcTime(this.timeOne, this.valueOne);
    this.timeTwo = this.calcTime(this.timeTwo, this.valueTwo);
  }

  updateValueOne(value){
    this.valueOne = value;
    if(this.valueOne < this.minValue || this.valueOne == null){
      this.valueOne = this.minValue;
    }
    if(this.valueOne > this.valueTwo){
      this.updateValueTwo(this.valueOne);
      this.valueTwoChange.emit(this.valueTwo);
    }
    this.timeOne = this.calcTime(this.timeOne, this.valueOne);
    this.valueOneChange.emit(this.valueOne);
  }


  updateValueTwo(value){
    this.valueTwo = value;
    if(this.valueTwo < this.minValue || this.valueTwo == null){
      this.valueTwo = this.minValue;
    } 
    if(this.valueTwo < this.valueOne){
      this.updateValueOne(this.valueTwo);
      this.valueOneChange.emit(this.valueOne);
    }
    this.timeTwo = this.calcTime(this.timeTwo, this.valueTwo);
    this.valueTwoChange.emit(this.valueTwo);
  }


  calcTime(timeObj: object, metricvalue: number) {
    timeObj['hours'] = this.padNum(Math.floor(metricvalue/3600), 2);
    timeObj['minutes'] = this.padNum(Math.floor((metricvalue - (parseInt(timeObj['hours']) * 3600))/60), 2);
    timeObj['seconds'] = this.padNum(metricvalue - (parseInt(timeObj['hours']) * 3600) - (parseInt(timeObj['minutes']) * 60), 2);
    return timeObj;
  }

  padNum(num: number, size: number) {
    var s = String(num);
    while (s.length < size) s = "0" + s;
    return s;
  }

}
